export const findError = (obj: any): { key: string; error: string } => {
  if (!obj || typeof obj !== 'object') {
    return { key: 'Unknown field', error: 'Invalid error structure' };
  }

  const entry = Object.entries(obj)[0]; // Get first key-value pair safely
  if (!entry) {
    return { key: 'Unknown field', error: 'No errors found' };
  }

  const [key, errors] = entry;

  if (
    Array.isArray(errors) &&
    errors.every(error => typeof error === 'string')
  ) {
    return { key, error: errors[0] ?? 'Unknown error' };
  }

  if (typeof errors === 'object' && errors !== null) {
    return findError(errors);
  }

  return { key, error: 'Unknown error' };
};
